import BmtScheduledMessagesAPI from '../../api/bmtScheduledMessages';

// Sprint AGENDAR-MSG (15/07/2026): pendentes por conversa (keyed por display_id).
// Sprint AGENDAR-MSG.1: create aceita tambem { templateName, templateParams }.
//
// Sem polling: diferente do bmtBotActivity (que reflete estado mudando sozinho
// no backend), aqui a lista so muda por acao do proprio operador (agendar /
// cancelar) ou quando o job dispara. Refetch no mount da conversa + apos cada
// mutacao cobre os dois casos sem custo de request a cada 5s.

export const state = {
  // { [display_id]: [ { id, content, scheduled_at, status, has_template, ... } ] }
  pendingByConv: {},
  uiFlags: { isFetching: false, isCreating: false },
};

export const getters = {
  pendingByConv: $state => $state.pendingByConv,
  getPendingForConv: $state => convId => $state.pendingByConv[convId] || [],
  uiFlags: $state => $state.uiFlags,
};

export const actions = {
  async fetch({ commit }, conversationId) {
    if (!conversationId) return;
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await BmtScheduledMessagesAPI.list(conversationId);
      commit('SET_PENDING', { conversationId, list: data.data || [] });
    } catch (error) {
      // Silencioso: se o backend cair, o composer nao quebra.
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  // Deixa o erro propagar: o modal precisa mostrar a mensagem do backend
  // (ex: "deve estar pelo menos 1 minuto no futuro").
  async create(
    { commit, dispatch },
    { conversationId, content, scheduledAt, templateName, templateParams }
  ) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await BmtScheduledMessagesAPI.schedule(conversationId, {
        content,
        scheduledAt,
        templateName,
        templateParams,
      });
      await dispatch('fetch', conversationId);
      return data.data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async cancel({ dispatch }, { conversationId, id }) {
    await BmtScheduledMessagesAPI.cancel(conversationId, id);
    await dispatch('fetch', conversationId);
  },
};

export const mutations = {
  SET_PENDING($state, { conversationId, list }) {
    // objeto novo => reatividade
    $state.pendingByConv = { ...$state.pendingByConv, [conversationId]: list };
  },
  SET_UI_FLAG($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
